(function () {
    'use strict';

    angular
        .module('appback')
        .factory('ListasService', ListasService);

    ListasService.$inject = ['$http'];

    function ListasService($http) {


        var service = {
            getListasCategoria: getListasCategoria,
            getMuestra: getMuestra,
            getPetPendientes: getPetPendientes,
            getListaCatnew: getListaCatnew,
            listaTotal: listaTotal,
            getListaEmpresa: getListaEmpresa,
            getListaPendientes: getListaPendientes,
            fueraPlazo: fueraPlazo,
            imprimirEtiquetas: imprimirEtiquetas,
            imprimirEtiquetasAnti: imprimirEtiquetasAnti,
            imprimirEtiquetasLista: imprimirEtiquetasLista,
            getBioquimicas: getBioquimicas,
            //getHormonas:getHormonas,
            marcarBioquimica: marcarBioquimica,
            cambiarDilucion: cambiarDilucion,
            descartarMuestra: descartarMuestra,
            getDeterminacionesByAnaliticas: getDeterminacionesByAnaliticas,
            modificarConfigBioq: modificarConfigBioq,
            generarLista: generarLista,
            getListaById: getListaById,
            imprimirEtiquetasPeticionId: imprimirEtiquetasPeticionId
        };

        return service;

        function imprimirEtiquetasPeticionId(peticion_id, callback) {
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                peticion_id: peticion_id
            });
            $http.post('/backend/peticionimpresa/imprimiretiquetaspeticionid', data, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }
        }

        function imprimirEtiquetas(lista, categoria_id, subcategoria, lab_id, tipoetiqueta, callback) {
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                categoria_id: categoria_id,
                subcategoria: subcategoria,
                tipoetiqueta: tipoetiqueta,
                lab_id: lab_id,
                lista: JSON.stringify(lista)
            });
            $http.post('/backend/peticionimpresa/imprimiretiquetas', data, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }
        }

        function imprimirEtiquetasAnti(lista, categoria_id, subcategoria, lab_id, tipoetiqueta, callback) {
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                categoria_id: categoria_id,
                subcategoria: subcategoria,
                tipoetiqueta: tipoetiqueta,
                lab_id: lab_id,
                lista: JSON.stringify(lista)
            });
            $http.post('/backend/peticionimpresa/imprimiretiquetasantibiogramas', data, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }
        }

        function generarLista(lab_id, cat_id, callback) {
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                lab_id: lab_id,
                cat_id: cat_id
            });
            $http.post('/backend/pendientes/generarlista', data, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }
        }

        function getListaById(id, callback) {
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/pendientes/getlistabyid', { params: { id: id } }, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }

        }

        function imprimirEtiquetasLista(lista, tipoetiqueta, callback) {
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                tipoetiqueta: tipoetiqueta,
                lista: JSON.stringify(lista)
            });
            $http.post('/backend/peticionimpresa/imprimirlistado', data, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }
        }

        function marcarBioquimica(anal, callback) {
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                anal: JSON.stringify(anal)
            });
            $http.post('/backend/pendientes/bioquimicascustom', data, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }
        }

        function modificarConfigBioq(peti, callback) {
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                peti: JSON.stringify(peti)
            });
            $http.post('/backend/pendientes/modificarconfigbioq', data, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }
        }

        function descartarMuestra(peti, callback) {
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }



            var data = $.param({
                peti: JSON.stringify(peti)
            });


            $http.post('/backend/pendientes/descartarmuestra', data, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }
        }
        function cambiarDilucion(peti, callback) {
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                peti: JSON.stringify(peti)
            });
            $http.post('/backend/pendientes/cambiardilucion', data, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }
        }


        function getListaCatnew(cat_id, page, filtros, callback) {

            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/pendientes/getlistascategoria', { params: { filtros: JSON.stringify(filtros),/*analiticas:JSON.stringify(analiticas),*/page: page, cat_id: cat_id } }, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }

        }

        function getDeterminacionesByAnaliticas(peticion, analiticas_ids, callback) {

            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/pendientes/getdeterminacionesbyanalitica', { params: { analiticas: analiticas_ids.join(","), peticion: JSON.stringify(peticion) } }, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }

        }
        function getBioquimicas(callback) {

            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/pendientes/getbioquimicas', { params: {} }, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }

        }

        /*function getHormonas(callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/pendientes/gethormonas', { params : { }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }*/
        function fueraPlazo(callback) {

            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/pendientes/fueraplazo', { params: {} }, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }

        }
        function getListaEmpresa(page, filtros, callback) {

            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/pendientes/getlistaempresa', { params: { filtros: JSON.stringify(filtros), page: page } }, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }

        }

        function getListaPendientes(page, analiticas, filtros, callback) {

            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/pendientes/getpendientes', { params: { analiticas: JSON.stringify(analiticas), filtros: JSON.stringify(filtros), page: page } }, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }

        }
        function listaTotal(cat_id, callback) {

            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/pendientes/getlistatotal', { params: { cat_id: cat_id } }, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }

        }
        function getListasCategoria(cat_id, callback) {

            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/trabajo/getlistascategoria', { params: { cat_id: cat_id } }, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }

        }

        function getPetPendientes(callback) {

            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/trabajo/getpeticionespendientes', { params: {} }, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }

        }


        function getMuestra(muestra_id, callback) {

            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/trabajo/getmuestra', { params: { muestra_id: muestra_id } }, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }

        }

    }
})();